<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formQuotation">
        <div class="px-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- Información adicional -->
              <app-custom-button [title]="'Información adicional'" [icon]="'pi pi-info-circle'" [severity]="'contrast'"
                (onClick)="openRegisterModal()">
              </app-custom-button>


              <app-custom-modal #registerModal [label]="'Información Adicional'" [header]="'Información Adicional'"
                [inputs$]="inputsForRegisterModal$" [children]="componentRegisterModal" [width]="'45vw'"
                [closable]="false" (params)="reloadRegisterModal($event)" hidden>
              </app-custom-modal>

              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="openPrintQuotationByVersion()"></app-custom-button>
              <app-custom-modal #printQuotation [header]="'Imprimir'" [children]="componentPrintQuotation"
                [closable]="true" [width]="'30vw'" [breakpoints]="breakpointsForPrint"
                [inputs$]="inputsForPrintQuotation$" [output$]="outputForPrintQuotation$" hidden></app-custom-modal>

              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFile [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteQuotation()"></app-custom-button>

              <app-custom-button [label]="expandedForm ? 'Ocultar' : 'Editar'" [width]="'5rem'"
                [icon]="expandedForm ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" [severity]="'contrast'"
                (onClick)="expandedForm = !expandedForm"></app-custom-button>

              <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
                [severity]="'success'" [variant]="undefined" (onClick)="createNewQuotation()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="quotationContract.userNameCreate"
                [createDate]="quotationContract.createDate" [userNameUpdate]="quotationContract.userNameUpdate"
                [updateDate]="quotationContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-12 col-12">
              <div class="row pe-md-3 pt-md-2">
                <div class="col-lg-4 col-md-5 col-sm-4 col-6">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4 col-6">
                  <app-custom-select formControlName="quotationTypeId" [labelText]="'Tipo'" [list]="listTypesQuotations"
                    [required]="true" (onChangeSelect)="changeTypeQuotation()"></app-custom-select>
                </div>
                <!-- Oculto las fechas al colapsar el formulario  -->
                <div class="col-lg-2 col-md-4 col-sm-4 col-6" [hidden]="!expandedForm">
                  <app-custom-datepicker formControlName="dateQuotation" [labelText]="'Fecha Cotización'"
                    [required]="true" (onChangeDate)="changeDateQuotation()"></app-custom-datepicker>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4 col-6" [hidden]="!expandedForm">
                  <app-custom-datepicker formControlName="dateExpiration" [labelText]="'Fecha Expiración'"
                    [required]="true" (onChangeDate)="disabledButtons()"></app-custom-datepicker>
                </div>
                <!-- Muestro el cliente al colapsar el formulario  -->
                <div class="col-lg-4 col-md-12 col-sm-11 col-12" [hidden]="expandedForm">
                  <app-custom-input-text [value]="formQuotation.controls['nameClient'].value"
                    [labelText]="'Nombre Cliente'" [required]="true" [maxLength]="150" [disabled]="true">
                  </app-custom-input-text>
                </div>
              </div>
              <div class="row  pe-md-3 pb-md-2" [hidden]="!expandedForm">
                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                    [class]="getClass('client')" (onChangeSelect)="getClient($event, true)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                  <app-custom-input-text formControlName="nameClient" [labelText]="'Nombre Cliente'" [required]="true"
                    [maxLength]="150">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="constructionSiteId" [labelText]="'Obra'"
                    [list]="filteredConstructionSites" [class]="getClass('constructionSite')"
                    (onChangeSelect)="getConstructionSite($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                  <app-custom-input-text formControlName="nameConstructionSite" [labelText]="'Nombre Obra'"
                    [maxLength]="70">
                  </app-custom-input-text>
                </div>
              </div>
            </div>
            <!-- 2 Fila -->
            <div class="col-lg-5 col-md-5 col-sm-12 col-12">
              <div class="row ps-md-3 pt-md-2">
                <div class="col-lg-3 col-md-6 col-sm-2 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-2 col-4 d-flex align-items-end gap-2">
                  <app-custom-button [icon]="stateButton.icon" [title]="stateButton.title" [severity]="stateButton.severity"
                    [disabled]="stateButton.disabled" (onClick)="updateStateQuotation()"></app-custom-button>
                  <app-custom-modal #rejectQuotation [header]="'Rechazar Cotización'"
                    [children]="componentRejectQuotation" [closable]="true" [width]="'30vw'"
                    [inputs$]="inputsForRejectQuotation$" [output$]="outputForRejectQuotation$"
                    hidden></app-custom-modal>

                  <app-custom-button [icon]="'pi pi-undo'" [title]="'Revertir estado'" [severity]="'primary'"
                    [disabled]="!disabledForm" (onClick)="revertStateQuotation()"></app-custom-button>
                </div>
                <div class="col-lg-5 col-md-8 col-sm-6 col-8">
                  <app-custom-select formControlName="versionId" [labelText]="'Versión'" [list]="listVersions"
                    (onChangeSelect)="getVersionSelect($event)"
                    [inputClass]="selectedVersionModel.active ? 'state-inactive':''"></app-custom-select>
                  <app-custom-modal #versionModal [header]="'Versiones'" [children]="componenteQuotationVersion"
                    [closable]="true" [width]="'70vw'" [inputs$]="inputsForVersionModals$"
                    [output$]="outputForVersionModals$" hidden></app-custom-modal>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-2 col-4 gap-2 d-flex align-items-end">
                  <app-custom-button [icon]="'pi pi-history'" [title]="'Estado Versión'" [severity]="'warn'"
                    [disabled]="disabledForm || quotationContract.quotationId == 0"
                    (onClick)="updateStateVersion()"></app-custom-button>
                  <app-custom-button [icon]="'pi pi-file-edit'" [title]="'Editar Versión'" [severity]="'primary'"
                    [disabled]="disabledForm || quotationContract.quotationId == 0"
                    (onClick)="openQuotationVersionModal()"></app-custom-button>
                </div>
              </div>
              <div class="row ps-md-3 pb-md-2" [hidden]="!expandedForm">
                <div class="col-lg-6 col-md-6 col-sm-4 col-12">
                  <app-custom-autocomplete formControlName="sellerId" [labelText]="'Vendedor'" [list]="listSellers"
                    [required]="true" (onChangeSelect)="getSeller($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-4 col-6">
                  <app-custom-select formControlName="priceListId" [labelText]="'Lista Precios'" [list]="listPricesList"
                    [required]="requiredPriceList" (onChangeSelect)="getPriceList($event)"></app-custom-select>
                </div>
                <div class="col-lg-6 col-md-8 col-sm-6 col-6 d-flex align-items-center gap-3 mt-2">
                  <app-custom-checkbox formControlName="swConditions" [labelText]="'Imp.Cond.'">
                  </app-custom-checkbox>
                  <app-custom-chip *ngIf="orderConsecutive !== ''" class="animate-fade-in"
                    [link]="orderId ? ['/order/register', orderId] : null" tooltip="Ver pedido"
                    [label]="'Pedido: ' + orderConsecutive" />
                </div>

                <div class="col-lg-6 col-md-4 col-sm-6 col-12 d-flex justify-content-end align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    [variant]="undefined" [width]="'5rem'" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
    <app-quotation-detail [quotationVersion]="selectedVersionModel" [permissionUpdatable]="permissionUpdatable"
      [quotationContract]="quotationContract" (emitQuantityDetails)="quantityDetails= $event"
      (costCenterDetailsCount)="costCenterDetailsCount = $event">
    </app-quotation-detail>
  </div>
</section>
<app-print-quotation id="print-quotation" [companyId]="companyId" [formatModel]="formatModel"
  [quotationPrintContract]="quotationPrintContract" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-quotation>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>